import { Box } from "@mui/material";
import { PickersCalendarHeaderProps } from "@mui/x-date-pickers";
import { Moment } from "moment";
import { ReactComponent as IconTriangleDown } from "assets/svg/triangle-down-fill.svg";
import { ReactComponent as IconChevronRight } from "assets/svg/chevron-right.svg";
import { ReactComponent as IconChevronLeft } from "assets/svg/chevron-left.svg";
import pxToRem from "theme/base/pxToRem";
import { useEffect, useState } from "react";
import { ActionBtn, CustomCalendarHeaderRoot, TextWrap, Title } from "./style";

const CustomCalendarHeader = (
  props: PickersCalendarHeaderProps<Moment> & { param?: any }
) => {
  const { currentMonth, onMonthChange, onViewChange, view } = props;
  const [isShowYearPicker, setShowYearPicker] = useState(false);

  const fnCustomeTitle = () => {
    const month = currentMonth.format("MMMM - YYYY").toString();
    const firstLetterCap = month.charAt(0);

    const remainingLetters = month.slice(1);

    const capitalizedWord =
      "Lịch chấm công " + firstLetterCap + remainingLetters;
    return <span>{capitalizedWord}</span>;
  };
  useEffect(() => {
    // thay đổi date thì xoay button down về vị trí ban đầu
    setShowYearPicker(false);
  }, [currentMonth]);

  // mở year or month calendar
  const handelOpenYearSelect = () => {
    if (view === "day") onViewChange("month");
    // if (view === "year") onViewChange("month");
  };

  const handelNextMonth = () => {
    onMonthChange(currentMonth.clone().add(1, "month"), "left");
  };

  //previous month
  const handelPrevMonth = () => {
    onMonthChange(currentMonth.clone().subtract(1, "month"), "right");
  };

  return (
    <CustomCalendarHeaderRoot>
      <TextWrap onClick={handelOpenYearSelect}>
        <Title variant="body1" onClick={handelOpenYearSelect}>
          {fnCustomeTitle()}
        </Title>
        <ActionBtn
          isActive={isShowYearPicker}
          onClick={() => {
            setShowYearPicker(!isShowYearPicker);
            if (view === "year") onViewChange("day");
          }}
        >
          <IconTriangleDown className="icon-down" />
        </ActionBtn>
      </TextWrap>
      <Box
        sx={{
          display: "flex",
          gap: pxToRem(8),
        }}
      >
        <ActionBtn onClick={handelPrevMonth}>
          <IconChevronLeft title="Previous month" />
        </ActionBtn>
        <ActionBtn onClick={handelNextMonth}>
          <IconChevronRight title="Next month" />
        </ActionBtn>
      </Box>
    </CustomCalendarHeaderRoot>
  );
};

export default CustomCalendarHeader;
